import { useGenericContext } from "../../hooks";
import { ProfileContext } from "./ProfileContext";

export const useProfile = () => useGenericContext(ProfileContext);
